<template>
  <div class="add-note-handwriting d-none d-md-flex position-absolute">
    <ib-handwriting
      :text="$t('handwriting.clickHereToAddYourFirstNote')"
      reverse
    >
      <template #arrow>
        <svg width="68" height="49" viewBox="0 0 68 49" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'mt-3'" v-bind:svg-inline="''" v-bind:width="'45'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M29.36 38.444h0c-.142-.41-.358-.577-.556-.628-.213-.056-.525-.01-.908.247h0l-.192.131c-.364.251-.805.556-1.287.706h0c-1.572.486-3.16.953-4.744 1.418-.932.273-1.862.546-2.787.823-3.242.978-6.549 1.919-10.026 2.096H8.86c-.196.009-.405.003-.615-.002a19.28 19.28 0 00-.293-.006l-.67-.007.26-.618c.033-.078.057-.138.078-.192l.021-.054c.027-.066.057-.14.102-.217v-.001c5.497-9.365 12.047-17.896 20.235-25.103h0c5.506-4.843 11.658-8.547 18.929-10.216 3.6-.827 7.261-1.375 11.03-.821h0c1.938.284 3.604 1.062 4.948 2.61a4.889 4.889 0 001.875 1.299c.561.216.938.204 1.204.081.27-.124.531-.41.752-.975.169-.436.292-.897.407-1.382.037-.155.074-.315.11-.477.077-.332.154-.674.242-1.003V6.15c.05-.187.037-.307 0-.402-.04-.105-.127-.225-.302-.377h0a15.99 15.99 0 00-5.7-3.207c-3.917-1.232-7.87-1.053-11.856-.135l-.101-.439.101.439c-8.043 1.852-14.96 5.907-21.302 11.106-6.884 5.647-12.639 12.34-17.742 19.638h0a328.397 328.397 0 01-1.17 1.662l-.483.688-.305-.783a1.703 1.703 0 01-.053-1.075c.11-.415.215-.839.321-1.267.265-1.07.536-2.166.914-3.214v-.001c1.446-3.966 2.966-7.903 4.493-11.833h0c.42-1.08.155-2.09-.153-3.268l-.085-.324v-.001c-.012-.046-.049-.116-.163-.254a4.992 4.992 0 00-.075-.087c-.211.227-.384.416-.55.61v.001c-2.476 2.886-3.969 6.316-5.187 9.93-.431 1.29-.84 2.596-1.25 3.906-1.072 3.425-2.155 6.884-3.687 10.172l-.001.003a27.302 27.302 0 00-1.603 4.24v.002a15.855 15.855 0 00-.616 4.02c-.005.7.21 1.221.57 1.598.366.384.92.657 1.65.782.4.062.801.099 1.205.108h.004c3.845.129 7.516-.835 11.232-1.922h0c2.13-.623 4.276-1.24 6.42-1.856 2.006-.577 4.01-1.153 5.998-1.733H28c.078-.022.16-.056.225-.093a.388.388 0 00.066-.047l1.07-4.294zm0 0l.003.006c.194.535.232 1.114.108 1.668l-.11-1.674z" fill="currentColor" stroke="#fff" stroke-width=".9"/></svg>
      </template>
    </ib-handwriting>
  </div>
</template>

<script>
import IbHandwriting from '@/components/_v2/IbHandwriting'

export default {
  name: 'AddNoteHandwriting',

  components: {
    IbHandwriting
  }
}
</script>

<style scoped lang="scss">
.add-note-handwriting {
  z-index: 1;
  left: 40%;
  top: -7%;
}
</style>
